import { useTour } from "@/context/TourContext";
import SpotlightOverlay from "./SpotlightOverlay";

/** Binds the onboarding tour's state (`TourContext`) to the shared spotlight engine. */
export default function SpotlightTour() {
  const { isOpen, stepIndex, steps, isSettling, next, back, end } = useTour();

  return (
    <SpotlightOverlay
      open={isOpen}
      steps={steps}
      index={stepIndex}
      isSettling={isSettling}
      onNext={next}
      onBack={back}
      onEnd={end}
    />
  );
}
